import APIClient from '@/shared/http/clients/api.js'

const resourceName = 'REDocumento'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllDocumentos = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/?limit=${limit}&index=${index}`, data, config)
const GetDocumentosByFiltro = (limit, index, pesquisa, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/documentos/filtro/?limit=${limit}&index=${index}`, pesquisa, data, config)
const UploadDocumento = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/documentos/upload`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const DownloadDocumento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/documentos/download/${id}`, data, config)
const GetBynameDocuments = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetBynameDocuments/${name}`, data, config)
const GetAllEmpreendimento = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEmpreendimento`, data, config)

const documentsmanagement = {
  GetAllDocumentos,
  GetDocumentosByFiltro,
  UploadDocumento,
  DownloadDocumento,
  GetBynameDocuments,
  GetAllEmpreendimento
}

export default documentsmanagement



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/documentsmanagement.js